<app-app-header></app-app-header>
<app-toast-notification></app-toast-notification>
<div class="main">
  <router-outlet></router-outlet>
</div>
<app-loader></app-loader>
<app-app-footer></app-app-footer>
